import React, { useState, forwardRef, Ref, InputHTMLAttributes } from 'react';
import { classNames } from 'primereact/utils';
import { getInputBaseClassName } from '../InputBase';
import { Icon } from '../Icon';
import './InputPassword.scss';

export type InputPasswordProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> & {
	inline?: boolean;
	value?: string | number | null;
	invalid?: boolean;
	minimal?: boolean;
};

export const InputPassword = forwardRef(
	(
		{ className, inline, value, invalid = false, minimal = false, ...restProps }: InputPasswordProps,
		ref: Ref<HTMLInputElement>
	) => {
		const [visible, setVisible] = useState(false);

		return (
			<div className="input-password-wrapper">
				<input
					ref={ref}
					type={visible ? 'text' : 'password'}
					className={classNames(
						getInputBaseClassName({ inline }),
						'input-password',
						{
							'input-invalid': invalid,
							'input-minimal': minimal,
						},
						className
					)}
					value={value ?? ''}
					{...restProps}
				/>
				<button type="button" className="toggle-visibility" onClick={() => setVisible((v) => !v)} tabIndex={-1}>
					<Icon name={visible ? 'eye-slash' : 'eye'} iconStyle="solid" className="text-base" />
				</button>
			</div>
		);
	}
);

InputPassword.displayName = 'InputPassword';
